export class MovieDetail {

    constructor(id) {
        if (!!id) {
            this.id = id
            this.$movieDetail = $(`#${this.id}`)

            this.init()
        } else {
            console.error('No id in construktor')
            return null
        }
    }

    init() {
        this.initHandlers()
        this.initPopover()
    }

    initHandlers() {
        var _this = this

        this.$movieDetail.find('.js-movie-detail__filter-nav-a').on('click', function (e) {
            e.preventDefault()
            _this.$movieDetail.find('.js-movie-detail__filter-nav-a').removeClass('is-active')
            $(this).addClass('is-active')

            _this.changeTab($(this).data('filter'))
        })
    }

    initPopover() {
        if ($(window).width() < 992) {
            return;
        }

        $('.js-movie-detail__filter-nav-a').each(function (i, el) {
            let wrap = $(el).closest('.js-movie-detail__filter-nav')

            $(el).popover({
                placement: 'top',
                html: true,
                trigger: 'hover',
                container: wrap
            })
        })
    }

    changeTab(filter) {
        this.$movieDetail.find('.js-movie-detail__filter-content').hide()
        this.$movieDetail.find(`.js-movie-detail__filter-content[data-filter="${filter}"]`).show()
    }

}
